import "./InputFiles.scss";

interface InputFilesProps {
  label: string;
  value: File[];
  invalidMsg?: string;
  onChange: (files: File[]) => void;
  darkMode: boolean;
}

const InputFiles = (props: InputFilesProps) => {
  return (
    <div className={"input-file-wrapper" + (props.darkMode ? " dark" : "")}>
      <label className="input-label">{props.label}</label>
      <div className="input-file-box">
        <label className="add-file-btn">
          <input
            type="file"
            multiple
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
            onChange={(e) => {
              const totalFiles = [
                ...props.value,
                ...Array.from(e.target.files ?? []),
              ];
              props.onChange(totalFiles);
            }}
          />
          <span className="add-file-text">Add Files</span>
        </label>
        {props.value.map((file, index) => (
          <div
            key={index}
            className={"file-item" + (props.darkMode ? " dark" : "")}
          >
            <div className="file-name" title={file.name}>
              {file.name}
            </div>
            <div
              className="remove-file-btn"
              onClick={() => {
                const newFiles = [...props.value];
                newFiles.splice(index, 1);
                props.onChange(newFiles);
              }}
            >
              ✕
            </div>
          </div>
        ))}
      </div>
      {props.invalidMsg && (
        <div className="invalid-msg">{props.invalidMsg}</div>
      )}
    </div>
  );
};

export default InputFiles;
